import React, { useEffect, useState } from "react";
import { Parents } from "../utils/CartegoryParent";
import { AdminCreateBrand, AdminViewSingleCategory, addCategory, getCategory, updateCategory, updateSubCategory } from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const UpdateCategoryForm = () => {
	const navigate = useNavigate();
	const params = useParams();
	const currentUser = useRecoilValue(userState);
	const [previewImageUrl, setPreviewImageUrl] = useState("");
	const [load, setLoad] = useState(false);
	const [showSubCategory, setShowSubCategory] = useState(false);
	const [showSubmit, setShowSubmit] = useState(false);
	const [showUpdateSub, setShowUpdateSub] = useState(false);
	const [allCartegory, setAllCartegory] = useState([]);
	const [ updateDataId, setUpdateDataId ] = useState(0);
	const [categoryData, setCategoryData] = useState({
		category: {},
		subcategories: [],
		brands: []
	});
	const [data, setData] = useState({
		categoryName: "",
		description: ""
	});
	const [subCategoryData, setSubCategoryData] = useState({
		subcategory: "",
		brands: ""
	})
	const [formData, setFormData] = useState({
		name: "",
		description: "",
		category: "",
		images: null,
	});



	const OnHandleChange = (e) => {
		const { name, value, type, files } = e.target;
		if (type === "file") {
			const avatarFile = files[0];
			const url = URL.createObjectURL(avatarFile);
			setPreviewImageUrl(url);

			setFormData((prev) => ({
				...prev,
				[name]: avatarFile,
			}));
		} else {
			setFormData((prevProfile) => ({
				...prevProfile,
				[name]: value,
			}));
		}
	};

	const ViewAllCartegory = async () => {
		try {
			const response = await AdminViewSingleCategory(currentUser?.data?.info?.id);
			setAllCartegory(response.data);
			
		} catch (err) {
			return err;
		}
	};
	useEffect(() => {
		getSingleCategory();
	}, []);
	const getSingleCategory = async () => {
		try {
			const res = await getCategory(params.categoryId);
			
			setCategoryData({
				category: res.category,
				subcategories: res.subCategories,
				brands: res.brands
			});
			setData({
				categoryName: res.category.categoryName,
				description: res.category.description
			})
		} catch (err) {
			return err;
		}
	}
	
	const onCategoryChange = (e) => {
		const { name, value } = e.target;
		
		setData((prev) => ({
			...prev,
			[name]: value
		}));
	}
	const onSubCategoryChange = (e) => {
		const { name, value } = e.target;
		
		setSubCategoryData((prev) => ({
			...prev,
			[name]: value
		}));
	}
	
	const onUpdateCategory = async (e) => {
		e.preventDefault();
        
		const res = await updateCategory({
			categoryId: params.categoryId,
            categoryName: data.categoryName,
			description: data.description
		});
		if (res) {
			
			Swal.fire({
				title: "Category Updated Successfully",
				icon: "success",
			}).then(() => {
				//window.location.reload();
				// navigate("/categories");
			});
		}
	}
	const onUpdateSubCategory = async (e) => {
		e.preventDefault();
        
		const res = await updateSubCategory({
			categoryId: params.categoryId,
			subCategoryId: updateDataId,
			subcategory: subCategoryData.subcategory,
			brands: subCategoryData.brands
		});
		if (res) {
			
			Swal.fire({
				title: "SubCategory/Brands Updated Successfully",
				icon: "success",
			}).then(() => {
				//window.location.reload();
				// navigate("/categories");
			});
		}
	}
	const onAction = (type, id) => {
		let subcategories = categoryData.subcategories.filter((item, i) => item.ID === id);
		let brands = categoryData.brands.filter((item, i) => item.subCategoryId === subcategories[0].ID);
		setSubCategoryData({
			subcategory: subcategories[0].subCategoryName,
			brands: brands[0].brandName
		});
		
		switch (type) {
			case "view":
				setShowUpdateSub(false);
				break;
			case "update":
				setUpdateDataId(id);
				setShowUpdateSub(true);
				break;
			// case "delete":

			// 	break;
		}
		setShowSubCategory(true)
	}
	return (
		<div>
			<section class='content-main'>
				<div class='row'>
					<div class='col-12'>
						<div class='content-header'>
							<h2 class='content-title'>Update Category</h2>
							<div>
									<button
										onClick={onUpdateCategory}
										class='btn btn-md rounded font-sm hover-up'>
										Update Category
									</button>
							</div>
						</div>
					</div>

				</div>
				<div className="row">
					<div class='col-md-6'>
						<div class='card mb-4'>
							{/* <div class='card-header'>
								<h4>Basic</h4>
							</div> */}
							<div class='card-body'>
								<form>
									<div class='mb-3'>
										<label for='product_name' class='form-label'>
											Category name <span style={{ color: 'red' }}>*</span>
										</label>
										<input
											required
											name='categoryName'
											onChange={onCategoryChange}
											type='text'
											value={data && data.categoryName}
											placeholder='Type here'
											class='form-control'
											id='category_name'
										/>
									</div>
									{/* <div className="row">
										<div className="col-md-6 mb-3">
											<label class='form-label'>Sub Category</label>
											<select
												id="subcategory"
												name='subcategory'
												// onChange={OnHandleChange}
												class='form-select'>
												<option value="">--Select sub category--</option>

												{allCartegory?.map((props) => (
													<option value={props.slug.replace("/", "")}>
														{props.slug.replace("/", "")}
													</option>
												))}
											</select>
										</div>
										<div className="col-md-6 mb-3">
											<label class='form-label'>Brands</label>
											<select
												id="brand"
												name='brands'
												// onChange={OnHandleChange}
												class='form-select'>
												<option value="">--Select brand--</option>

												{allCartegory?.map((props) => (
													<option value={props.slug.replace("/", "")}>
														{props.slug.replace("/", "")}
													</option>
												))}
											</select>
										</div>
									</div> */}
									<div className="row">
										<div class='col-md-12 mb-4'>
											<label class='form-label'>Full description<span style={{ color: 'red' }}>*</span></label>
											<textarea
												required
												name='description'
												onChange={onCategoryChange}
												value={data && data.description}
												placeholder='Type here'
												class='form-control'
												rows='4'></textarea>
										</div>
									</div>
									{/* <div className="row mb-3" >
										<div
											role="button"
											className="col-md-12 d-flex justify-content-end"
											style={{ color: '#bb2d5e', fontWeight: 400 }}
											onClick={() => setShowSubCategory(!showSubCategory)}>
											<i class="material-icons md-post_add"></i><span>Add Subcategory</span>
										</div>
									</div> */}

								</form>
							</div>
						</div>
						{/* <!-- card end// --> */}
					</div>
					{/* </div> */}

				</div>
				<div className="row">
					<div className="col-md-6 card mb-3">
						<div class="card-body">
							<div class="table-responsive">
								<table class="table table-hover">
									<thead>
										<tr>
											<th scope="col">S/N</th>
											<th scope="col">SubCategory Id</th>
											<th scope="col">SubCategory Name</th>
											<th scope="col" class="text-end">
												Action
											</th>
										</tr>
									</thead>
									<tbody>
										{categoryData ? categoryData.subcategories.map((category, i) =>
											<tr key={"category" + i}>
												<td>{(i + 1)}</td>
												<td>{category.ID}</td>
												<td>{category.subCategoryName}</td>
												<td class="text-end">
	
														<div class="mb-5">
															<div
																role="button"
																class="dropdown-item"
																onClick={(e) => onAction("view", category.ID)}
															>
																View
															</div>
															<div
																role="button"
																class="dropdown-item"
																onClick={(e) => onAction("update", category.ID)}
															>
																Update
															</div>
															{/* <div
																role="button"
																class="dropdown-item text-danger"
																onClick={(e) => onAction("delete", category.ID)}
															>
																Delete
															</div> */}
														</div>
												</td>
											</tr>)
											: (
												<div>No order Found</div>
											)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
					{showSubCategory ?
						// <div className="row">
						<div class='col-md-6'>
							<div class='card mb-3'>
								<div class='card-header'>
									<h4>Sub Category ({subCategoryData.subcategory})</h4>
								</div>
								<div class='card-body'>
									<form>

										<div class='mb-3'>
											<label for='product_name' class='form-label'>
												Sub-Category name <span style={{ color: 'red' }}>*</span>
											</label>
											<input
												required
												name='subcategory'
												onChange={onSubCategoryChange}
												type='text'
												value={subCategoryData.subcategory}
												placeholder='Type here'
												class='form-control'
												id='subcategory_name'
											/>
										</div>
										<div class='mb-3'>
											<label for='product_name' class='form-label'>
												Brands (comma separated list) <span style={{ color: 'red' }}>*</span>
											</label>
											<textarea
												required
												name='brands'
												onChange={onSubCategoryChange}
												value={subCategoryData.brands}
												placeholder='Type here'
												class='form-control'
												rows='4' />
										</div>

										{/* <div class='mb-4'>
										<label class='form-label'>Full description<span style = {{color : 'red'}}>*</span></label>
										<textarea
											required
											name='description'
											onChange={OnHandleChange}
											placeholder='Type here'
											class='form-control'
											rows='4'></textarea>
									</div> */}
										<div className="d-flex justify-content-end">
											{/* <button class='btn btn-light rounded font-sm mr-5 text-body hover-up'>
									Save to draft
								</button> */}

											{showUpdateSub ?
												<button
													onClick={onUpdateSubCategory}
													class='btn btn-md rounded font-sm hover-up'>
													Update SubCategory/Brands
												</button> :
												<button
													onClick={() => setShowSubCategory(false)}
													class='btn btn-md rounded font-sm hover-up'>
													Close
												</button>
											}
										</div>
									</form>
								</div>
							</div>
							{/* <!-- card end// --> */}
						</div> : ""
					}
				</div>
			</section>
		</div>
	);
};

export default UpdateCategoryForm;
